import React, { lazy, Suspense, useEffect } from "react";
import "../styles/app/app.scss";

import { Provider } from "react-redux";
import { Route, Router, Switch } from "react-router-dom";
import AppContext from "./appContext";
import history from "@history";

import routes from "./RootRoutes";
// import { Store } from "./redux/Store";
import configureStore from "./redux/Store";

import { renderRoutes } from "react-router-config";
import { Loading } from "@gull";
import Auth from "./auth/Auth";
import RootRoutes from "./RootRoutes";
import ErrorBoundary from "./Components/ErrorBoundary/ErrorBoundary";
import toastr from "toastr";
import { UserService } from "app/_services/UserService/UserService";
import "toastr/build/toastr.min.css";
import PrivateRoute from "./Components/Routing/PrivateRoute";
import PublicRoute from "./Components/Routing/PublicRoute";
import ForgotPassword from "./_mobile/_pages/MobileSignIn/ForgotPassword";
import PersonalInfoDetails from "./_pages/_healthSafetyEnvironment/PersonalInfo/PersonalInfoDetails";

// Mobile Layout
const MobileAuthLayout = lazy(() =>
  import("./layouts/MobileAuthLayout/MobileAuthLayout")
);
const MobileLayout = lazy(() => import("./layouts/MobileLayout/MobileLayout"));

toastr.options = {
  positionClass: "toast-bottom-right",
  timeOut: 10000,
};
//codefire
let { store } = configureStore();

function App() {
  useEffect(() => {
    const authToken = localStorage.getItem("jwt_token");

    if (authToken) UserService.loggedUser();
  }, []);

  return (
    <AppContext.Provider value={{ routes }}>
      <Provider store={store}>
        <Auth>
          <Suspense fallback={<Loading />}>
            <Router history={history}>
              <Switch>
                <PublicRoute
                  path="/personal-info/details"
                  component={PersonalInfoDetails}
                  isPublic
                />
                <PublicRoute
                  path="/mobile/auth/forgot-password"
                  component={ForgotPassword}
                />
                <PublicRoute path="/mobile/auth/:page" component={MobileAuthLayout} />
                <PrivateRoute isMobile path="/mobile" component={MobileLayout} />

                <ErrorBoundary>{renderRoutes(RootRoutes)}</ErrorBoundary>
              </Switch>
            </Router>
          </Suspense>
        </Auth>
      </Provider>
    </AppContext.Provider>
  );
}

export default App;
